export default __webpack_public_path__ + "static/media/mountain.7f07b18c.jpg";